import React from "react";
import { toast } from "sonner";
import ThemeSelector from "../ThemeSelector";
import DesignSettings from "../../pages/DesignSettings";

// Settings > Brand & Theme: the app theme (ThemeSelector) and the admin
// interface preferences (formerly /crm/design-settings) on one tab.
export default function BrandSettings() {
  return (
    <div className="space-y-8" data-testid="settings-brand">
      <section className="max-w-7xl space-y-4">
        <div className="border-b border-[#FF10F0]/20 pb-4">
          <h2 className="text-lg font-semibold text-white">App Theme</h2>
          <p className="mt-1 text-sm text-zinc-400">Choose the appearance used across the app. Pink neon is the GP default.</p>
        </div>
        <ThemeSelector onThemeChange={() => toast.success("Theme applied")} />
      </section>
      <section className="space-y-4">
        <div className="border-b border-[#FF10F0]/20 pb-4">
          <h2 className="text-lg font-semibold text-white">Admin interface</h2>
          <p className="mt-1 text-sm text-zinc-400">Accent colour, dark mode and density for this browser.</p>
        </div>
        <DesignSettings />
      </section>
    </div>
  );
}
